// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ftr-space[data-v-ad948b9c]{flex-grow:1;min-width:0}@media (min-width:960px){.app-footer-section[data-v-ad948b9c]{margin-left:56px}}", ""]);
// Exports
module.exports = exports;
